<template>
<span>
  <spinner class="spinner-centered" v-if="dataLoading === true" line-fg-color="#28AFAF" size="large"></spinner>
  <v-app v-else>
    <!-- navigation drawer -->
    <v-navigation-drawer
      v-if="!dataLoading"
      persistent
      v-model="drawer"
      enable-resize-watcher
      app
    >
      <v-card class="elevation-1">
        <v-card-media>
          <v-container fluid fill-height>
            <v-layout justify-center
                align-center>
            <v-avatar
                    :size="avatarSize"
                    :tile="false"
                  >
                  <img :src="meProps.logo_url || defaultLogo" alt="avatar">
              </v-avatar>
            </v-layout>
          </v-container>
        </v-card-media>
        <v-card-title>
          <div>
            <span>{{ meProps.first_name }} {{ meProps.last_name}}</span><br>
            <span>{{ meProps.email }}</span>
            
          </div>
        </v-card-title>
      </v-card>
      <v-spacer></v-spacer>
      <v-list>
          <v-list-tile v-for="item in menuItems" :key="item.title" router-link :to="item.route">
            <v-list-tile-action primary>
              <v-icon left>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <!-- end of navigation drawer -->
    
    <!-- toolbar -->
    <v-toolbar color="indigo" dark fixed app>
        <v-toolbar-title :style="$vuetify.breakpoint.smAndUp ? 'width: 300px; min-width: 250px' : 'min-width: 72px'" class="ml-0 pl-3">
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <span class="hidden-xs-only">Songa Insurance</span>
      </v-toolbar-title>
        <div class="d-flex align-center" style="margin-left: auto">
          <v-btn flat @click="logout">
            <v-icon left>lock</v-icon>
            Logout
          </v-btn>
        </div>
      </v-toolbar>
    <!-- end of toolbar -->
    <main>
      <v-content>
        <v-container fluid fill-height>
            <router-view></router-view>
        </v-container>
      </v-content>
    </main>
    <v-footer color="indigo" app>
      <span class="white--text">&copy; Songa Insurance</span>
    </v-footer>
  </v-app>
  </span>
</template>

<script>
import axios from 'axios'
import Spinner from 'vue-simple-spinner'
import defaultLogo from '../../../assets/placeholder_profile_photo-200x200.png'
export default {
    components: {
      Spinner
    },
    data: () => ({
      drawer: true,
      dataLoading: true,
      defaultLogo: defaultLogo,
      menuItems: [
          {icon: 'supervisor_account', title: 'Admins', route: '/admin/admins'},
          {icon: 'work', title: 'Agencies', route: '/admin/agencies'},
          {icon: 'assignment', title: 'Insurance Policies', route: '/admin/policies'},
          {icon: ' format_list_bulleted', title: 'Insurance Plans', route: '/admin/plans'},
          {icon: 'content_copy', title: 'Transaction Reports', route: '/admin/transaction'},
          {icon: 'assessment', title: 'Sales Reports', route: '/admin/sales'},
          {icon: 'description', title: 'Summary Reports', route: '/admin/summary'}
        ],
        meProps: {}
    }),
    props: {
      source: String
    },    
    computed: {
      avatarSize () {
        return `150px`
      }
    },
    methods: {
      toHomepage() {
        location.href = ''
      },
      logout () {
            this.$auth.destroyToken()
            this.$router.push('/auth/login');
      }
    },
    created() {
      axios.get('/me')
      .then(res => {
        this.meProps = res.data;
        this.dataLoading = false
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.indigo {
  background-color: #28AFAF !important
}
.spinner-centered {
  position: fixed; /* or absolute */
  top: 50%;
  left: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/Views/AdminFront.vue